import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import Feather from 'react-native-vector-icons/Feather';

export const Overlay = styled.TouchableOpacity`
  flex: 1;
  background-color: rgba(0, 0, 0, 0.45);
  padding: ${RFValue(24)}px;
  justify-content: center;
`;

export const Card = styled.View`
  background-color: ${({theme}) => theme.colors.price_card};
  border-radius: ${RFValue(16)}px;
  padding: ${RFValue(20)}px;
`;

export const Title = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.title};
  margin-bottom: ${RFValue(8)}px;

`;

export const BodyText = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  line-height: ${RFValue(18)}px;
`;

export const Actions = styled.View`
  margin-top: ${RFValue(16)}px;
`;

export const LinkWrapper = styled.View`
  margin-top: ${RFValue(8)}px;
  align-items: center;
`;

export const LinkItemContainer = styled.View`
  justify-content: flex-start;
  flex-direction: row;
  margin-top: ${RFValue(12)}px;
`;

export const CloseButton = styled.TouchableOpacity`
  position: absolute;
  top: ${RFValue(8)}px;
  right: ${RFValue(8)}px;

  width: ${RFValue(28)}px;
  height: ${RFValue(28)}px;
  align-items: center;
  justify-content: center;
  background-color: ${({theme}) => theme.colors.attention};
  border-radius: ${RFValue(40)}px;
`;

export const CloseIcon = styled(Feather)`
  color: ${({theme}) => theme.colors.shape};

`;
